<div class="container mx-auto mt-4">
  <div class="card">
    <div class="card-body">
      <form (ngSubmit)="handleFormSubmit()">
        <div class="form-group">
          <label for="exampleInputEmail1">Numero de cedula</label>
          <input
            type="text"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            [ngClass]="{
              'is-valid': documentNumber.touched && documentNumber.valid,
              'is-invalid': documentNumber.touched && !documentNumber.valid
            }"
            [formControl]="documentNumber"
          />
          <div
            *ngIf="documentNumber.touched && !documentNumber.valid"
            class="invalid-feedback"
          >
            El Documento es requerido
          </div>
          <small id="emailHelp" class="form-text text-muted"
            >Verificaremos si tu documento esta registrado en nuestro
            sistema</small
          >
        </div>
        <div class="form-group">
          <re-captcha
            [formControl]="recaptcha"
            name="captcha"
            required
            siteKey="6Lc4ptYZAAAAAFiuTq4rQysS1q3ocGSr_BoGoHuY"
          ></re-captcha>
        </div>
        <div
          *ngIf="recaptcha.touched && !recaptcha.valid"
          class="invalid-feedback"
        >
          Porfavor llene el captcha
        </div>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!recaptcha.valid || !documentNumber.valid"
        >
          Validar
        </button>
      </form>
    </div>
  </div>
</div>
